import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxFormsState} from '../../@interfaces';
import {FORMS_CLEAR_CONFIGS, FORMS_SET_CONFIGS} from './constants';

const reducer: Reducer = (state: IReduxFormsState = initialState, action: IReduxAction): IReduxFormsState => {
	switch (action.type) {
		case FORMS_SET_CONFIGS:
			return {...state, configsLoaded: true};

		case FORMS_CLEAR_CONFIGS:
			return {...state, configsLoaded: false};

		default:
			break;
	}

	return state;
};

export default reducer;
